<div *ngIf="!!organisation" class="render-organisation-row">
  <tui-avatar
    [src]="organisation.photoId | getImageSrc | tuiFallbackSrc: (organisation.shortName || '' | tuiInitials) | async"
    [style.background]="
      !organisation.photoId && organisation.shortName ? (organisation.shortName | tuiAutoColor) : ('' | tuiAutoColor)
    "
    [size]="'m'"
    [round]="true"
  ></tui-avatar>

  <div class="render-organisation-row__info">
    <span class="render-organisation-row__text tui-text_body-m">
      {{ organisation.shortName }}
    </span>

    <span class="render-organisation-row__text tui-text_body-s text_color-grey">
      {{ organisation.fullName }}
    </span>
  </div>
</div>
